import { useState } from "react";

import { Button, clsx } from "@alpacahq/ui/old";

import { OrderTicket } from "~/v2/components/orderTicket";
import { useLocalStorage } from "~/v2/hooks/useLocalStorage";

export const EquityOrderTicketDemo = () => {
  const [symbol, _setSymbol] = useState<string>("AAPL");

  const [equityOrderTicketOpen, setEquityOrderTicketOpen] =
    useLocalStorage<boolean>("devtools-equity-order-ticket-open");

  const [size, setSize] = useState<"min" | "max">("min");

  return (
    <div className="rounded border border-gray-300">
      <button
        type="button"
        onClick={() =>
          setEquityOrderTicketOpen(!(equityOrderTicketOpen ?? false))
        }
        className="flex w-full items-center justify-between bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100"
      >
        <h2 className="m-0 font-semibold text-lg">Equity Order Ticket Demo</h2>
        <span className="text-gray-500">
          {(equityOrderTicketOpen ?? false) ? "-" : "+"}
        </span>
      </button>
      {(equityOrderTicketOpen ?? false) && (
        <div
          className={clsx(
            "m-4 w-full",
            size === "min" && "max-w-[285px]",
            size === "max" && "max-w-[511px]",
          )}
        >
          <div className="w-full">
            <div className="mb-4 flex w-full gap-2">
              <Button variant="secondary" onClick={() => setSize("min")}>
                Min Size
              </Button>
              <Button variant="secondary" onClick={() => setSize("max")}>
                Max Size
              </Button>
            </div>
            <div className="w-full">
              <h4>Order Ticket</h4>
              <OrderTicket symbol={symbol} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
